import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7zy7uj26c: FaireProductEntity = {
  token: "p_t7zy7uj26c",
  type: "product",
  name: "spring watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/0e49d0687e40abe965269dfea660d37a5639651ff343f6bbfbcf9515df109df5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bfa092c7707e188678633393d7592df65b52e03ed34f9276ee8fbef0c02379e.jpeg",
    "https://cdn.faire.com/fastly/b5cfd0189fccf99cf3f9e3448ef811389a05bfcd2a4be23ef9ec188e174d8f0f.jpeg",
    "https://cdn.faire.com/fastly/316eac7fa3c8850c41c520031fd8ae96fad02e2b2aa977eff121d989463e4314.jpeg",
    "https://cdn.faire.com/fastly/a18e2295887bf50c784627bacf3dde1f0566c45c2333e073efef3c537feeb013.jpeg",
    "https://cdn.faire.com/fastly/77a4bb433f60c475504ce68cb881acb3eb3005876a037afc883f4add591cb2ae.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve spring illustrations — a bunny, baby chick, tulips, lilacs, an Easter basket, a bicycle with flowers, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong Easter and spring seller. Reorder 6–8 weeks before Easter. Pairs well with the paintable notecards for a seasonal display.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:06.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
